export default "__VITE_ASSET__qiJwu1AM__"